import classnames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import { isCompletedState } from "../../documentList/helpers";
import { State } from "../../state";
import { AccountPresenterKind } from "../model/presenter/types";
import { selectCell as selectCellAction } from "../model/selectedCells/actions";
import { getPeriodSelectedFn } from "../model/selectedCells/selector";
import { getLanguage, getSpread } from "../model/spread/selector";
import { Spread } from "../model/spread/types";
import AccountMetadata from "./AccountMetadata";
import AccountTotalCell from "./AccountTotalCell";
import ChevronDown from "./chevron_down.svg";
import ChevronDownBlue from "./chevron_down_blue.svg";
import ChevronDownError from "./chevron_down_error.svg";
import ChevronRight from "./chevron_right.svg";
import ChevronRightBlue from "./chevron_right_blue.svg";
import ChevronRightError from "./chevron_right_error.svg";
import ErrorFlyout from "./ErrorFlyout";
import { accountValueKey } from "./helpers";

interface AccountTotalBaseProps {
  account: AccountPresenterKind<"CALCULATED">;
  hierarchyLevel: number;
  handleExpand: (event: React.MouseEvent<HTMLDivElement>) => void;
  expanded: boolean;
  language?: string | null;
}

export interface AccountTotalProps extends AccountTotalBaseProps {
  selectCell: typeof selectCellAction;
  periodSelected: number;
  spread: Spread | undefined;
}

export const getChevronIcon = (
  expanded: boolean,
  exceptionEligible: boolean,
  hasException: boolean
) => {
  if (hasException) {
    return expanded ? ChevronDownError : ChevronRightError;
  }
  if (exceptionEligible) {
    return expanded ? ChevronDownBlue : ChevronRightBlue;
  }

  return expanded ? ChevronDown : ChevronRight;
};

export class AccountTotal extends React.Component<AccountTotalProps> {
  constructor(props: AccountTotalProps) {
    super(props);
  }

  public render() {
    const {
      account,
      hierarchyLevel,
      handleExpand,
      expanded,
      selectCell,
      periodSelected,
      spread
    } = this.props;

    const documentException = account.documentExceptions[periodSelected];

    const rowHasException = () => {
      if (account.periodValues.length === 1 && !account.documentExceptions[0]) {
        return false;
      } else if (
        account.periodValues.length > 1 &&
        !account.documentExceptions[0] &&
        !account.documentExceptions[1]
      ) {
        return false;
      } else {
        return true;
      }
    };

    const { exceptionEligible } = account;

    const language = this.props.language;
    const name =
      (language &&
        account.translatedNames &&
        account.translatedNames[language]) ||
      account.name;

    return (
      <div
        className={classnames(
          "AccountRow__container",
          "AccountRow__container--total",
          `AccountRow__container--period-${account.periodValues.length}`,
          { "AccountRow__container--calculated": exceptionEligible }
        )}
      >
        <div
          className={classnames(
            "AccountRow__hover-container",
            `AccountRow__hover-container--level-${hierarchyLevel}`
          )}
        >
          <div
            onClick={handleExpand}
            className={classnames(
              "AccountRow__name",
              "AccountRow__name--total",
              {
                "AccountRow__name--total--checked":
                  exceptionEligible && !rowHasException(),
                "AccountRow__name--total--unchecked": !exceptionEligible,
                "AccountRow__value--error": rowHasException()
              }
            )}
          >
            {exceptionEligible ? (
              <div className="AccountRow__indicator">
                <div
                  className={classnames("AccountRow__left-indicator", {
                    "AccountRow__left-indicator--error": rowHasException()
                  })}
                />
              </div>
            ) : null}
            <div className="AccountRow__text">
              {name}
              <AccountMetadata account={account} />
            </div>
            <button className="ChevronArrowButton">
              <img
                className="ChevronArrow material-icons"
                src={getChevronIcon(
                  expanded,
                  exceptionEligible,
                  rowHasException()
                )}
              />
            </button>
          </div>
          {account.periodValues.map((periodValue, index) => (
            <AccountTotalCell
              account={account}
              period={index}
              key={accountValueKey(account, index)}
              selectCell={selectCell}
            />
          ))}
        </div>
        {documentException &&
        (spread !== undefined && !isCompletedState(spread.status)) ? (
          <ErrorFlyout
            account={account}
            periodIndex={periodSelected}
            selectCell={selectCell}
            documentException={documentException}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state: State, ownProps: AccountTotalBaseProps) => ({
  periodSelected: getPeriodSelectedFn(state)(
    ownProps.account.spreadSheetType,
    ownProps.account.id
  ),
  spread: getSpread(state),
  language: getLanguage(state)
});

export default connect(
  mapStateToProps,
  { selectCell: selectCellAction }
)(AccountTotal);



// WEBPACK FOOTER //
// ./src/spread/chartOfAccounts/AccountTotal.tsx